

























import { Vue } from "vue-property-decorator";

import Info from "@/views/invest/form/stadium_info.vue"
import Estimate from "@/views/invest/mine/stadium_estimate_info.vue"
import Cooperation from "@/views/invest/mine/stadium_cooperation_info.vue"
import Business from "@/views/invest/mine/stadium_business_info.vue"

export default Vue.extend({
  name: "StadiumEstimate",
  components: { Info, Estimate, Cooperation, Business },
  data() {
    return {
      id    : "",
      active: 1,
    }
  },
  methods: {
    /* 提交审核 */
    async submit(op: number) {
      const params = { estimate_id: this.id, op }
      const res = await this.$store.dispatch("invest/submit", params);
      if (res.Code == 200) {
        this.$success({ content: "提交成功！" })
        if (op == 1) {
          const cooperation = this.$refs.cooperation as any
          cooperation.get_info()
        }
        if (op == 2) {
          const business = this.$refs.business as any
          business.get_info()
        }
      } else {
        this.$error({
          content: res.Message,
        })
      }
    }
  },
  mounted() {
    const query = { ...this.$route.query };
    if (query.id != "") this.id = query.id as string
    if (query.active) this.active = Number(query.active)
    console.log(this.active)
  }
})

